import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { ChangeEmployerService } from '../change-employer.service';
import { Subscription } from 'rxjs';
import { EntityLicenseModel } from '../../../model/entityLicenseModel';
import { StorageService } from '../../../shared/security/StorageService';

@Component({
  selector: 'app-sever-notification',
  templateUrl: './change-employer-notification.component.html',
  styleUrls: ['./change-employer-notification.component.css']
})
export class ChangeEmployerNotificationComponent implements OnInit, OnDestroy {

  agree: boolean = false;
  submitAgree: boolean = false;
  startFunction: StartFunctionResponseModel = {};
  employmentInfoSubscription: Subscription;
  employmentInfo: EntityLicenseModel;


  constructor(private startFunctionService: StartFunctionService,
    private router: Router,
    private changeEmployerService: ChangeEmployerService,
    private storageService: StorageService) {
    this.startFunction = this.storageService.getStartFunctionData();
    // if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
    //   this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
    //   console.log("In SEVER NOTIF : " + this.startFunction.Workflow.Steps[1].StepDisplayName);
    // }

    this.employmentInfoSubscription = this.changeEmployerService.getNotifyEmploymentInformation().subscribe(data => {
      this.employmentInfo = data;
      console.log("Employment Info : " + this.employmentInfo);
    });


  }

  ngOnInit() {
    this.agree = false;
  }


  goBackHome() {
    this.router.navigate(['/home']);
  }

  agreePath(agreeForm) {
    this.submitAgree = true;
    if (agreeForm && this.agree) {
      this.router.navigate(['/selectNewEmployer']).then(() => {
        this.changeEmployerService.getNotifyAgreement().emit(this.agree);
        this.changeEmployerService.getNotifyEmploymentInformation().emit(this.employmentInfo);
        this.startFunctionService.getNotifyStepInProgress().emit(true);

      }
      );
    }
  }

  ngOnDestroy(): void {
    //this.employmentInfoSubscription.unsubscribe();
  }

@HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.startFunctionService.getNotifyStepInProgress().emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/change-employer/change-employer-notification/change-employer-notification.component.ts